const getBrowserTimeZone = () => new Intl.DateTimeFormat().resolvedOptions().timeZone;

export default getBrowserTimeZone;
